import FacilitiesPage from '@/features/companies/[companyId]/facilities/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/facilities/')({
  component: FacilitiesPage,
})
